<!--
    班级管理-批量导入学生（结果）
    功能：展示导入学生数据成功与失败信息
-->
<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      title="导入结果"
      width="500px"
    >
      <el-alert
        v-if="resultInfo.isSuccess"
        :closable="false"
        :title="`${resultInfo.isSuccess} 条记录导入成功！`"
        description=""
        class="alert"
        type="success"/>
      <el-alert
        v-if="resultInfo.inSchool"
        :closable="false"
        :title="`${resultInfo.inSchool.count} 条记录已存在【学校】：`"
        :description="resultInfo.inSchool.names"
        type="warning"
        class="alert"/>
      <el-alert
        v-if="resultInfo.inClasses"
        :closable="false"
        :title="`${resultInfo.inClasses.count} 条记录已存在【班级】：`"
        :description="resultInfo.inClasses.names"
        type="warning"
        class="alert"/>
      <el-alert
        v-if="resultInfo.notComplete"
        :closable="false"
        :title="`缺少必填项:`"
        :description="resultInfo.notComplete.noData.join()"
        type="error"
        class="alert"/>
      <!-- <el-alert
        v-if="resultInfo.notComplete&&resultInfo.notComplete.noName.length"
        :closable="false"
        :title="`缺少【姓名】：`"
        :description="resultInfo.notComplete.noName.join()"
        type="error"
        class="alert"/>
      <el-alert
        v-if="resultInfo.notComplete&&resultInfo.notComplete.noMobile.length"
        :closable="false"
        :title="`缺少【电话】：`"
        :description="resultInfo.notComplete.noMobile.join()"
        type="error"
        class="alert"/> -->
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'ClassUploadDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    resultInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    handleClose() {
      this.$emit('close-dialog');
    },
  },
};
</script>
<style lang="scss" scoped>
.alert{
    margin-bottom: 15px;
    /deep/ .el-alert__title{
        font-weight: 600;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/ClassManage/components/FileResultDialog/index.vue